import {InfoWindowController} from "./info-window.controller";

export const InfoWindowComponent = {
    controller: InfoWindowController,
    template: '<a class="list-view__item__info" title="More info..." ng-click="$ctrl.open($event)"><i class="glyphicon glyphicon-info-sign"></i></a>',
    bindings: {
        title: '<',
        body: '<'
    }
};



// WEBPACK FOOTER //
// ./src/js/components/info-window/info-window.component.js